import { load } from '@redux/middleware/persist';
import { createSlice } from '@reduxjs/toolkit';
const persistedValue = load('enquiry.persisted', {
    name: '',
    postcode: '',
    email: '',
    phoneNumber: '',
});
export const initialState = {
    persisted: persistedValue,
};
const slice = createSlice({
    initialState,
    name: 'enquiry',
    reducers: {
        add: (state, action) => {
            state.persisted.name = action.payload.name;
            state.persisted.email = action.payload.email;
            state.persisted.postcode = action.payload.postcode;
            state.persisted.phoneNumber = action.payload.phoneNumber;
        },
    },
});
export const { add } = slice.actions;
export const name = slice.name;
export const reducer = slice.reducer;
